import Timeout = NodeJS.Timeout;
import { Requester } from "./requester";
import { ModalBuilder } from "./modal-builder";
import { SimpleTable, SimpleTableData } from "./simple-table";
import { ButtonBuilder } from "./button-builder";
import { PanelDefinition } from "../dashboard/panels/dashboard-panel";
import { DashboardHelper } from "../dashboard/dashboard-helper";

export class DialogTable
{
    private readonly table = new SimpleTable();
    private readonly url: string;
    private readonly onDataChanged: () => void;
    private refreshTimeout: Timeout;

    constructor(url: string, onDataChanged?: () => void)
    {
        this.url = url;
        this.onDataChanged = onDataChanged;
    }

    async open()
    {
        const definition: PanelDefinition = await Requester.get(this.url);
        const modal = ModalBuilder.createModal(definition.Title);
        modal.dialog.css("width", "880px");
        this.table.appendTo(modal.body);
        await this.reloadData(definition.DataUrl);

        for (const button of DashboardHelper.getButtons(definition.Buttons, async () =>
        {
            await this.reloadData(definition.DataUrl);
            if (this.onDataChanged)
            {
                this.onDataChanged();
            }
        }))
        {
            ButtonBuilder.get({
                name: button.name,
                isSecondary: true,
                cssClass: "margin-top-5 margin-right-5",
                onClick: button.onClick
            }).appendTo(modal.body);
        }
        modal.container.modal({ show: true });
    }

    private async reloadData(dataUrl: string): Promise<void>
    {
        if (this.refreshTimeout)
        {
            clearTimeout(this.refreshTimeout);
        }
        const data = (<SimpleTableData> await Requester.post(dataUrl, null));
        this.table.setData(data, () =>
        {
            this.reloadData(dataUrl);
            if (this.onDataChanged)
            {
                this.onDataChanged();
            }
        });
        if (data.NextRefresh)
        {
            this.refreshTimeout = setTimeout(() => this.reloadData(dataUrl), data.NextRefresh * 1000);
        }
    }
}
